import AppTable from '@/components/AppTable';
import { columnSorter } from '@/utils/formatters';
import { Modal } from 'antd';
import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import AppTableQuery from '@/components/AppTableQuery';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import { getTrackingDetails } from '@/services/revenue.service';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

function DetailModal({
  open,
  setOpen,
  trackingData,
  recordDetail,
  setRecordDetail,
  selectedPrizeRecord,
}) {
  const [query, setQuery] = useState({
    isdn: null,
  });
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(1);
  const offset = (pageIndex - 1) * pageSize + 1;
  const [searchValue, setSearchValue] = useState(null);
  const isBreakpoint = useMediaQuery(`(max-width: ${mediaQueryPoints.mdPlus}px)`);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  const { data, isLoading, refetch, isRefetching } = usePaginatedQuery(
    () =>
      getTrackingDetails({
        prizeId: selectedPrizeRecord?.id,
        numCollected: recordDetail?.pieces_collected,
        limit: pageSize,
        offset,
        ...query,
      }),
    ['tracking-details', selectedPrizeRecord?.id, recordDetail, pageSize, offset, query],
    {
      enabled: open && !!selectedPrizeRecord?.id && !!recordDetail?.pieces_collected,
    }
  );

  // console.log('list_user_id', recordDetail);
  // const processDetailData = useMemo(() => {
  //   if (!data?.dataDetail) return [];
  //   if (_.isEmpty(recordDetail) || !recordDetail?.list_user_id) return [];

  //   const { list_user_id } = recordDetail;

  //   console.log('data?.dataDetail', data?.dataDetail);
  //   const listArrId = list_user_id
  //     .split(',')
  //     .map((item) => item.trim())
  //     .filter(Boolean);
  //   const dataUserFilter = listArrId.map((id) => {
  //     const result = data?.dataDetail.filter((item) => +item.user_id === +id);
  //     let formatData = {};
  //     result.forEach((item) => {
  //       const pieceName = item.piece_name?.toString().trim();
  //       if (!pieceName) return;

  //       if (formatData[pieceName]) {
  //         formatData[pieceName].count += 1;
  //       } else {
  //         formatData[pieceName] = { ...item, count: 1 };
  //       }
  //     });
  //     const { isdn, total_pieces } = data[0] || {};
  //     return {
  //       pieces: formatData,
  //       total_pieces: total_pieces || 0,
  //       isdn: isdn || '',
  //       user_id: id,
  //       key: `user_${id}`,
  //     };
  //   });

  //   return dataUserFilter;
  // }, [trackingData?.dataDetail, recordDetail]);

  // console.log('data', data);

  const prizeDetailCols = [
    {
      title: 'No.',
      dataIndex: 'id',
      key: 'id',
      render: (_, __, index) => {
        return <span className="">{index + 1}</span>;
      },
    },
    {
      title: 'Phone Number',
      dataIndex: 'isdn',
      key: 'isdn',
      sorter: columnSorter('isdn'),
      render: (value) => (value ? value : '-'),
    },
    ...Array.from(new Set(data?.dataPieces.map((item) => item.name)))
      .sort()
      .map((item, index) => {
        return {
          title: `Piece ${item}`,
          key: `piece_${index}_${item}`,
          render: (record) => {
            const pieceData = record?.pieces_collected.find((p) => p.piece_name === item);
            return <span>{pieceData?.number_piece || '0'}</span>;
          },
        };
      }),
    {
      title: 'Total Pieces',
      dataIndex: 'pieces_collected',
      key: 'total_pieces',
      render: (value) => {
        const userPieceCollected = value?.reduce((sum, item) => sum + item.number_piece, 0);

        if (!userPieceCollected || userPieceCollected <= 0) return '0';
        return <span>{userPieceCollected}</span>;
      },
    },
  ];

  const handleQuery = () => {
    setQuery({
      isdn: searchValue,
    });
    setPageIndex(1);
  };

  const handleReset = () => {
    setSearchValue(null);
    setQuery({
      isdn: null,
    });
    setPageIndex(1);
  };

  return (
    <Modal
      open={open}
      width={'100%'}
      footer={null}
      title={<h3 className="font-medium">Details</h3>}
      onCancel={() => {
        setOpen(false);
      }}
      afterClose={() => {
        handleReset();
        setRecordDetail({});
      }}
      // className="max-w-full"
      centered
    >
      <AppTableQuery
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        searchPlaceholder="Phone number"
        hasFilter={false}
        handleQuery={handleQuery}
        handleReset={handleReset}
        className={`${isMobile ? '!w-full' : '!w-fit'} !bg-[#fafafa] border border-[#f0f0f0] !py-2 !px-3 !pb-3`}
        flexProps={{
          justify: 'flex-start',
          gap: 20,
        }}
        colSpans={[24, 0, 0]}
      />
      <AppTable
        columns={prizeDetailCols}
        dataSource={data?.dataDetail || []}
        loading={isLoading || isRefetching}
        onRefresh={refetch}
        bordered={false}
        disableColumnVisibility={true} // Disable column visibility for modal
        className="pb-6"
        defaultSize="middle"
        hasPagination={true}
        pageIndex={pageIndex}
        pageSize={pageSize}
        totalItems={data?.dataTotal || 0}
        onPageChange={(page, size) => {
          setPageIndex(page);
        }}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
        }}
        scroll={{
          x: isMobile ? 769 : isBreakpoint ? 993 : 'max-content',
        }}
      />
    </Modal>
  );
}

export default DetailModal;
